import script from "./CategoryList.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryList.vue?vue&type=script&setup=true&lang=js"

import "./CategoryList.vue?vue&type=style&index=0&id=4852f44b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4852f44b"]])

export default __exports__